import React from "react";
import { Link } from "react-router-dom";

interface IManagementTeamDetails {
  name: string;
  role: string;
  description: string;
  linkedin: string;
  image: string;
}

const ManagementTeam: React.FC = () => {
  const managementTeamDetails: IManagementTeamDetails[] = [
    {
      name: "Ajay Sukhija",
      role: "Chief Operating Officer - Information Technology",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      linkedin: "http://linkedin.com/in/ajay-sukhija-1b4667132",
      image: "/company/management/ajay.png",
    },
    {
      name: "Anil Khilan",
      role: "Chief Executive Officer - Skills",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      linkedin: "http://linkedin.com/in/anil-kumar-khillan-09265a26a",
      image: "/company/management/anil.png",
    },
    {
      name: "Divyanshu Goel",
      role: "Chief Financial Officer",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      linkedin: "",
      image: "/images/divyanshu-goel.jpg",
    },
    {
      name: "Vishesh Sama ",
      role: "Assistant Vice President of Operations",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      linkedin: "",
      image: "/images/vishesh-sama.png",
    },
  ];

  return (
    <div>
      <div className="flex justify-start mb-5">
        <div className="flex justify-center w-full md:justify-start">
          <div className="w-full max-w-[11rem] sm:max-w-[18rem] md:max-w-[19rem] lg:max-w-[20rem] sm:ml-[3rem] xl:max-w-[40rem] md:ml-[30px]">
            <h3 className="font-light pb-1 xl:pb-5 xl:pb-50 text-center md:text-left text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-6xl text-[#182152]">
              Management Team
            </h3>
            <div className="w-full p-[0.75px] bg-[#FE4329FC]" />
          </div>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-5 xl:pt-7 xl:px-10">
        {managementTeamDetails.map((member) => {
          return (
            // todo: change key from description id needed
            <div
              className="w-full flex justify-center items-center"
              key={member.description}
            >
              <ManagementCard
                name={member.name}
                role={member.role}
                linkedin={member.linkedin}
                description={member.description}
                image={member.image}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ManagementCard = ({
  name,
  role,
  linkedin,
  description,
  image,
}: IManagementTeamDetails) => {
  return (
    <div className="flex flex-col w-full h-full max-w-72">
      <img src={image} alt="" className="h-56 w-full object-cover object-top" />
      <div className="space-y-1 max-h-28 p-3 border border-t-0 bg-white h-32 flex flex-col justify-between">
        <div>
          <h4 className="font-medium">{name}</h4>
          <h5 className="font-light text-sm">{role}</h5>
          {/* <p className="text-[#5F6980] text-xs">{description}</p> */}
        </div>
        <div className="">
          {linkedin && (
            <Link to={linkedin} target="_blank">
              <img src="/company/linkedin.svg" alt="" className="w-6" />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManagementTeam;
